// @ts-nocheck
import { Component } from 'react';
import { createRemoteVideoMenuButtonEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { grantModerator } from '../../base/participants/actions';
import { getParticipantById } from '../../base/participants/functions';
// CUSTOM
import { socketEmit } from '../../../../socket';
import { getLocalParticipant } from '../../base/participants';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../customise/constant';
import { CURRENT_ROOM_NAME } from '../../webjam/constant';
/**
 * Abstract dialog to confirm granting moderator to a participant.
 */
export default class AbstractGrantModeratorDialog extends Component {
    /**
     * Initializes a new {@code AbstractGrantModeratorDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    /**
     * Callback for the confirm button.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    _onSubmit() {
        const { dispatch, participantID } = this.props;
        sendAnalytics(createRemoteVideoMenuButtonEvent('grant.moderator.button', {
            'participant_id': participantID
        }));
        // CUSTOM
        // send recording status and recording name, if any new user is connect or moderator change the new user role to moderator
        const { getLocalParticipant, roomorIpAddress, recTimeStamp, stemRecording, isRecording, devicesUsers, iAmRecorder, recordingModalCount } = this.props;
        console.log("recordingModalCount", recordingModalCount);
        setTimeout(function () {
            if (isRecording > 0) {
                socketEmit("recording_status", {
                    roomName: CURRENT_ROOM_NAME,
                    location: window.location.origin,
                    timestamp: recTimeStamp,
                    status: true,
                    isRecording: isRecording,
                    stemStatus: stemRecording,
                    iAmRecorder,
                    jitsiId: getLocalParticipant.id,
                    type: 3,
                    count: recordingModalCount
                });
            }
        }, 5000);
        if (devicesUsers) {
            socketEmit("device_user", {
                device_user: devicesUsers,
                jitsiId: getLocalParticipant.id,
                roomName: roomorIpAddress,
                location: window.location.origin,
            });
        }
        // END
        dispatch(grantModerator(participantID));
        return true;
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code AbstractMuteEveryoneDialog}'s props.
 *
 * @param {IReduxState} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component.
 * @returns {IProps}
 */
export function abstractMapStateToProps(state, ownProps) {
    return {
        participantName: getParticipantById(state, ownProps.participantID)?.name,
        // CUSTOM
        isRecording: state['features/recording']?.sessionDatas?.filter(e => e.mode == "file" && e.status == "on")?.length,
        getLocalParticipant: getLocalParticipant(state),
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        recTimeStamp: state[FEATURE_CUSTOM_REDUX].recTimeStamp,
        stemRecording: state[FEATURE_CUSTOM_REDUX].stemRecording,
        devicesUsers: state[FEATURE_CUSTOM_REDUX].devicesUsers,
        iAmRecorder: state['features/base/config'].iAmRecorder,
        recordingModalCount: state[FEATURE_CUSTOM_REDUX_V2].recordingModalCount,
        // END
    };
}
